import api from 'api'
import { downloadBlob, filenameFromContentDisposition } from 'lib/downloadBlob'

export async function downloadInvoicePdf(invoiceId: number) {
  const response = await api.get<Blob>(
    `/admin/charges/invoices/${invoiceId}/pdf`,
    { responseType: 'blob' }
  )

  const filename = filenameFromContentDisposition(
    response.headers['content-disposition'],
    `invoice_${invoiceId}.pdf`
  )
  downloadBlob(new Blob([response.data]), filename)
}
